<div style="display: inline" title="{{ statusTooltip }}">
  @if (showBubble) {
    <span [ngClass]="statusClass" class="bubble">
      @if (showLoader) {
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="3"></circle>
        </svg>
      }
    </span>
  }
  @if (item.enabled === false) {
    <div class="disabled-icon"></div>
  }
</div>

@if (showName) {
  <span [ngClass]="deleteClass" id="Label_{{ item.id }}">{{ item.name }}</span>
}
